import { useEffect } from 'react';
import styled from 'styled-components';

import { Box } from 'components/Box';
import { SecondaryButtonRouterLink } from 'components/Button';
import { Button } from 'components/Button/Button';
import { setHideSalarySurveyAd } from 'modules/main/store/ducks/layout';
import { useMainDispatch } from 'modules/main/store/hooks/useMainDispatch';
import { colors, fontWeights, gutterWidth } from 'theme';
import { trackClicked } from 'utils/analytics/track/trackClicked';
import { trackEventOnce } from 'utils/analytics/track/trackEventOnce';
import { getStaticImageSrc } from 'utils/getImageSrc';
import { NOTIFICATIONS, dismissNotification } from 'utils/localNotifications';

const CloseButton = styled(Button)`
  opacity: 0.999; /* is invisible without this, why? */
`;

export function SalarySurveyBanner() {
  const dispatch = useMainDispatch();

  const dismiss = () => {
    dismissNotification(NOTIFICATIONS.SALARY_SURVEY_CTA);
    dispatch(setHideSalarySurveyAd(true));
  };

  useEffect(() => {
    trackEventOnce('Displayed: Salary Survey Ad', {
      context: 'Header Banner',
    });
  }, []);

  return (
    <Box
      data-qa-id="banner-ad"
      data-ad-type="salary-survey"
      position="relative"
      zIndex={101}
      bg={colors.brandBlue}
      color="white"
      display="flex"
      py={12}
      pl={gutterWidth / 2}
      pr={gutterWidth / 2 - 16}
    >
      <Box
        position="absolute"
        left={0}
        top={0}
        width={1}
        height="100%"
        backgroundImage={`url('${getStaticImageSrc(
          'salary-survey-banner.svg',
        )}')`}
        backgroundSize="cover"
        backgroundPosition="center"
      />
      <Box
        position="relative"
        minHeight={[160, 80, null, 92]}
        width={1}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap={['wrap', 'nowrap', null, null]}
      >
        <Box
          pr={[0, 10, null, null]}
          mt={['5px', 0, null, null]}
          mb={[2, 0, null, null]}
          fontSize={[16, null, null, 18]}
        >
          <Box
            display={['block', null, null, 'inline']}
            mb={['10px', null, null, 0]}
            fontWeight={fontWeights.semiBold}
          >
            Take our 10 minute anonymous survey
          </Box>{' '}
          to learn how much you could be earning.
        </Box>
        <SecondaryButtonRouterLink
          to="/salaries"
          reverse
          onClick={() => {
            trackClicked('Clicked: Salary Survey Ad', {
              cta_type: 'Button',
              button_text: 'Take Our Survey',
              url: '/salaries',
              context: 'Header Banner',
            });
          }}
        >
          <Box minHeight={24} display="flex" alignItems="center">
            <Box display="block">Take Our Survey</Box>
          </Box>
        </SecondaryButtonRouterLink>
      </Box>
      <CloseButton
        data-qa-id="close-banner-ad-button"
        onClick={dismiss}
        variant="legacy-tertiary-white"
        iconName="close"
      />
    </Box>
  );
}
